module.exports = __webpack_public_path__ + "media/חיות.810f997a.mp3";